'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function RootPage() {
  const router = useRouter()

  useEffect(() => {
    router.replace('/en')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}
